import { getPrice } from './orderFormPrices';

const createProductsList = (basket, selectedFees, code, sectorId) => {
  const mapBasket = basket?.map(item => {
    const {
      selectedDiet: { dietId } = {},
      selectedOption: { dietOptionId } = {},
      sets,
    } = item || {};

    return {
      productId: `${dietId}-${dietOptionId}`,
      quantity: sets,
      price: getPrice(item, code, sectorId),
      customValue: 'Dieta',
    };
  });

  const mapAdditionalFees = selectedFees?.map(item => {
    const { amount, defaultPrice, possibleSideOrderId } = item || {};

    return {
      productId: possibleSideOrderId,
      quantity: amount,
      price: defaultPrice * amount,
      customValue: 'Opłata jednorazowa',
    };
  });

  return mapBasket.concat(mapAdditionalFees);
};

export const handleYouLeadCart = (basket, selectedFees, code, sectorId) => {
  return {
    cart: {
      transactionId: basket[0].orderId,
      products: createProductsList(basket, selectedFees, code, sectorId),
    },
  };
};

export const handleYouLeadPurchase = (
  basket,
  selectedFees,
  code,
  sectorId,
  firstName,
  lastName
) => {
  return {
    purchase: {
      transactionId: basket[0].orderId,
      products: createProductsList(basket, selectedFees, code, sectorId),
      userId: `${firstName} ${lastName}`,
    },
  };
};

export const monitorTrackForm = (
  firstName,
  lastName,
  phone,
  email,
  cityName,
  consentMarketing,
  consentProcessing
) => {
  const youLeadTag = document.createElement('script');
  youLeadTag.innerHTML = `Monitor.TrackForm('Formularz zamówienia', [ {'yl-name': '${firstName}'}, {'yl-lastName': '${lastName}'}, {'yl-phone': '${phone}'}, {'yl-email': '${email}'}, {'yl-city': '${cityName}'}, {'yl-consent_processing': '${consentProcessing}'}, {'yl-consent_marketing': '${consentMarketing}'} ]);`;
  youLeadTag.async = true;
  document.body.appendChild(youLeadTag);
};
